

































import {
  computed,
  defineComponent,
  ref,
  PropType,
} from '@vue/composition-api';

const Paginator = defineComponent({
  props: {
    design: {},
    modelValue: { default: 1 },
    perPage: { default: 10 },
    totalPage: {},
    totalItem: { default: 0 },
    perPages: { type: Array as PropType<number[]>, default: () => [10, 20, 30] },
  },
  setup(props, { emit }) {
    const internalPage = ref(props.modelValue);

    function emitNextPage() {
      internalPage.value += 1;
      emit('nextPage');
      emit('input', internalPage.value);
    }
    function emitPrevPage() {
      internalPage.value -= 1;
      emit('prevPage');
      emit('input', internalPage.value);
    }

    const computedPerPageDisplay = computed(() => props.perPages?.map((total: number) => `${total} รายการ`) || []);

    return {
      internalPage,
      emitNextPage,
      emitPrevPage,
      computedPerPageDisplay,
    };
  },
});

export default Paginator;
